<template>
  <v-app class="rounded">
    <!--        <v-card outlined rounded elevation="3">-->

    <div class="card card-custom">
      <!--begin::Header-->
      <div class="card-header py-3">
        <div class="card-title align-items-start flex-column">
          <h3 class="card-label font-weight-bolder text-dark">تکمیل پروفایل</h3>
          <span class="text-muted font-weight-bold font-size-sm mt-1"
          >تکمیل اطلاعات شخص یا سازمان</span
          >
        </div>
        <div class="card-toolbar">
          <v-row>
            <v-col>
              <v-btn color="error" class="px-5">
                <v-icon>mdi-close</v-icon>
                انصراف
              </v-btn>
            </v-col>
            <v-col>
              <v-btn color="success" @click="sendData" class="text-white px-5" :loading="loading">
                <v-icon class="pl-2">mdi-content-save-all-outline</v-icon>
                {{user.auth_validate == $STATUS.DONE ? 'به روز رسانی': 'ذخیره'}}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>

      <div v-if="user.auth_validate == $STATUS.DONE">
        <edit-profile v-model="editInfo" :errorsMessage="errorsMessage"></edit-profile>

      </div>
      <div>
        <v-container class="p-10" v-if="user.auth_validate == $STATUS.DRAFT">
          <v-layout align-center justify-center>
            <v-flex xs12 align-self-center>
              <v-row class="fill-height" justify="center" align="center">
                <v-col>
                  <v-card-title class="text-center data-notFound justify-content-center">
                    انتخاب کنید چی هستید؟
                  </v-card-title>
                </v-col>
              </v-row>
              <v-radio-group v-model="person">
                <v-row>
                  <v-col>
                    <v-radio
                        :label="`شخص حقیقی `"
                        :value="realPerson"
                        v-on:change="real"
                    ></v-radio>
                  </v-col>
                  <v-col>
                    <v-radio
                        :label="`شخص حقوقی`"
                        :value="legalPerson"
                        v-on:change="legal"
                    ></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>

              <hr>

              <div v-if="realPersonStatus">
                <v-row>

                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="شماره همراه  " type="text" class=""
                                  :value="user.phone" dense outlined/>
                  </v-flex>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="شماره ثابت" type="text"
                                  outlined dense
                                  :rules="rules.telephone" v-model="editInfo.telephone"/>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="نام پدر" type="text"
                                  :error-messages="errorsMessage === null ? [] : errorsMessage.father_name"
                                  outlined dense
                                  :rules="rules.fatherName" v-model="editInfo.fatherName"/>
                  </v-flex>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="کد ملی" type="text"
                                  :error-messages="errorsMessage === null ? [] : errorsMessage.mcode"
                                  outlined dense
                                  :rules="rules.nationalCode" v-model="editInfo.nationalCode"/>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="شماره شناسنامه" type="text"
                                  outlined dense
                                  :error-messages="errorsMessage === null ? [] : errorsMessage.nid"
                                  :rules="rules.id" v-model="editInfo.id"/>
                  </v-flex>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <date-picker label="تاریخ تولد"
                                 view="year"
                                 format="YYYY-MM-DD"
                                 display-format="jYYYY-jMM-jDD"
                                 max="2006-01-01"
                                 start="2006-01-01"
                                 :error-messages="errorsMessage === null ? [] : errorsMessage.birthday"

                                 :rules="rules.birthday" v-model="editInfo.birthday"/>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="محل تولد" type="text" outlined dense
                                  :error-messages="errorsMessage === null ? [] : errorsMessage.born_city"

                                  :rules="rules.placeBirthday" v-model="editInfo.placeBirthday"/>
                  </v-flex>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="کد پستی" type="text" outlined dense
                                  :rules="rules.postalCode" v-model="editInfo.postalCode"/>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="ایمیل" type="email"  outlined dense
                                  :value="user.email" readonly

                    />
                  </v-flex>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="نحوه آشنایی" type="text" outlined dense v-model="editInfo.introduction"/>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-file-input label="عکس کارت ملی" show-size :rules="rules.nationalCodePic"
                                  v-model="editInfo.nationalCodePic"
                                  prepend-icon=""
                                  outlined dense
                                  append-icon="mdi-camera"
                                  :error-messages="errorsMessage === null ? [] : errorsMessage.nidimage"

                    />
                  </v-flex>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="پلاک" :rules="rules.plaque" type="text"
                                  outlined dense
                                  v-model="editInfo.plaque"/>
                  </v-flex>

                </v-row>
                <v-row>
                  <v-textarea label="آدرس کامل" rows="3"
                              outlined dense
                              :error-messages="errorsMessage === null ? [] : errorsMessage.address"
                              color="teal" :rules="rules.address" v-model="editInfo.address"/>
                </v-row>
              </div>

              <div v-if="legalPersonStatus">
                <v-row>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field direction="rtl" label="نام شرکت/فروشگاه" type="text"
                                  class="mt-4"
                                  :error-messages="errorsMessage === null ? [] : errorsMessage.name"
                                  :rules="rules.companyName" v-model="editInfo.companyName" dense
                                  outlined
                                  />
                  </v-flex>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="شماره ثبت" type="text" class="mt-4"
                                  :rules="rules.registration_number" outlined
                                  :error-messages="errorsMessage === null ? [] : errorsMessage.registration_number"

                                  v-model="editInfo.registrationNumber" dense/>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field direction="rtl" label="کد اقتصادی" type="text"  outlined
                                  :error-messages="errorsMessage === null ? [] : errorsMessage.economic_code"
                                  :rules="rules.economic_code" v-model="editInfo.economicCode" dense
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="شناسنامه ملی سازمانی" type="text"
                                  :rules="rules.organization_identity" outlined
                                  :error-messages="errorsMessage === null ? [] : errorsMessage.organization_identity"
                                  v-model="editInfo.organizationIdentity" dense/>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">

                    <v-select
                        :items="items"
                        item-text="name"
                        item-value="valueName"
                        label=" نوع شرکت"
                        dense outlined
                        return-object
                        v-on:change="chaneCompanyType"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-text-field label="حوزه فعالیت" type="text" outlined
                                  v-model="editInfo.activity" dense/>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-file-input counter
                                  dense outlined
                                  append-icon="mdi-camera"
                                  prepend-icon=""
                                  :rules="rules.registration_ad"
                                  :error-messages="errorsMessage === null ? [] : errorsMessage.registration_ad"
                                  v-model="editInfo.registrationAd"
                                  label="تصویر آگهی ثبت شرکت">
                    </v-file-input>

                  </v-flex>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-file-input counter
                                  dense outlined
                                  append-icon="mdi-camera"
                                  prepend-icon=""
                                  v-model="editInfo.lastPublishedAd"
                                  :error-messages="errorsMessage === null ? [] : errorsMessage.last_published_ad"
                                  :rules="rules.last_published_ad"
                                  label="تصویر آخرین آگهی رسمی منتشر شده">
                    </v-file-input>

                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-file-input counter
                                  append-icon="mdi-camera"
                                  prepend-icon=""
                                  dense outlined
                                  v-model="editInfo.statute"
                                  label="تصویر اساسنامه شرکت">
                    </v-file-input>

                  </v-flex>
                  <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
                    <v-file-input counter
                                  prepend-icon=""
                                  append-icon="mdi-camera"
                                  dense outlined
                                  v-model="editInfo.argentLetterPic"
                                  :error-messages="errorsMessage === null ? [] : errorsMessage.agent_letterpic"
                                  label="تصویر نامه معرفی نماینده شرکت">
                    </v-file-input>

                  </v-flex>
                </v-row>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>


    </div>

  </v-app>
</template>

<script>
import EditProfile from "./EditProfile";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
  name: "EmailSettings",
  components: {
    EditProfile
  },

  data() {


    return {
      editInfo: {
        name: null,
        phone: null,
        telephone: null,
        username: null,
        fatherName: null,
        nationalCode: null,
        id: null,
        birthday: null,
        placeBirthday: null,
        postalCode: null,
        email: null,
        introduction: null,
        nationalCodePic: null,
        picWithNationalCode: null,
        plaque: null,
        yourCatch: null,
        address: null,
        companyName: null,
        registrationNumber: null,
        economicCode: null,
        organizationIdentity: null,
        activity: null,
        registrationAd: null,
        lastPublishedAd: null,
        statute: null,
        argentLetterPic: null,
        companyType: null,
        legalPersonStatus: false,
        realPersonStatus: false,
      },
      errorsMessage: [],
      rules: {
        companyName: [val => (val || '').length > 0 || 'فیلد نام شرکت یا فروشگاه اجباری می باشد.'],
        registration_number: [val => (val || '').length > 0 || 'فیلد شماره ثبت اجباری می باشد.'],
        economic_code: [val => (val || '').length > 0 || 'فیلد کد اقتصادی اجباری می باشد.'],
        organization_identity: [val => (val || '').size > 0 || 'فیلد شناسنامه ملی سازمانی اجباری می باشد.'],
        registration_ad: [val => (val || '').size > 0 || 'فیلد تصویر اگهی ثبت شده اجباری می باشد.'],
        last_published_ad: [val => (val || '').size > 0 || 'فیلد تصویر آخرین اگهی رسمی منتشر شده اجباری می باشد.'],
        telephone: [val => (val || '').length > 0 || 'فیلد شماره ثابت اجباری می باشد. '],
        fatherName: [val => (val || '').length > 0 || 'فیلد نام پدر اجباری می باشد. '],
        nationalCode: [val => (val || '').length > 0 || 'فیلد کدملی اجباری می باشد. '],
        birthday: [val => (val || '').length > 0 || 'فیلد  کدملی اجباری می باشد. '],
        id: [val => (val || '').length > 0 || 'فیلد  شماره شناسنامه اجباری می باشد. '],
        placeBirthday: [val => (val || '').length > 0 || 'فیلد  محل تولد اجباری می باشد. '],
        postalCode: [val => (val || '').length > 0 || 'فیلد  کد پستی اجباری می باشد. '],
        nationalCodePic: [val => (val || '').size > 0 || 'فیلد  عکس کارت ملی اجباری می باشد. '],
        address: [val => (val || '').length > 0 || 'فیلد  آدرس اجباری می باشد. '],
        plaque: [val => (val || '').length > 0 || 'فیلد  پلاک اجباری می باشد. '],
      },
      loading:false,
      items: [
        {name: 'دولتی', valueName: 'governmental'},
        {name: 'خصوصی', valueName: 'private'},
        {name: 'سهامی عام', valueName: 'common_stock'},
        {name: 'سهامی خاص', valueName: 'special_stock'}
      ],
      legalPerson: 'legal_person',
      realPerson: 'real_person',
      person: 1,
      legalPersonStatus: false,
      realPersonStatus: false,

    }
  },
  methods: {
    real() {
      this.realPersonStatus = true
      this.legalPersonStatus = false
      this.errorsMessage = null
    },
    legal() {
      this.legalPersonStatus = true
      this.realPersonStatus = false
      this.errorsMessage = null
    },
    chaneCompanyType(item) {
      console.log(item)
      this.editInfo.companyType = item.valueName
    },

    sendData() {
      this.getUserStatusType();
      if (this.legalPersonStatus) {
        return this.legalData();
      }
      if (this.realPersonStatus) {
        return this.realData()
      }
      this.$toast.error('لطفا یک مورد را انتخاب کنید.')
    },
    getUserStatusType() {
      if (this.editInfo.legalPersonStatus)
        return this.legalPersonStatus = true;
      if (this.editInfo.realPersonStatus)
        return this.realPersonStatus = true;
      return;
    },
    legalData() {
      let vm = this;
      this.loading = true
      let formData = new FormData();
      formData.append('type', 'legal');
      formData.append('name', vm.editInfo.companyName);
      formData.append('registration_number', this.english(vm.editInfo.registrationNumber));
      formData.append('economic_code', this.english(vm.editInfo.economicCode));
      formData.append('organization_identity', this.english(vm.editInfo.organizationIdentity));
      formData.append('activity', vm.editInfo.activity);
      formData.append('registration_ad', vm.editInfo.registrationAd)
      formData.append('telephone', vm.editInfo.telephone)
      formData.append('last_published_ad', vm.editInfo.lastPublishedAd)
      formData.append('statute', vm.editInfo.statute);
      formData.append('agent_letterpic', vm.editInfo.argentLetterPic);
      formData.append('company_type', vm.editInfo.companyType);
      // formData.append('type', 'company');
      formData.append('agree', 1);
      this.requestApiPost('confirmprofile', formData, this.configurationFile())
          .then(({data}) => {
            this.loading = false
            this.$toast.success('با موفقیت ثبت شد');
            this.authority();
          }).catch(({response}) => {
        this.loading = false
        vm.errorsMessage = response.data.errors

      })
    },
    realData() {
      const vm = this;
      this.loading = true;
      let formData = new FormData();
      formData.append('type', 'regular');
      formData.append('father_name', vm.editInfo.fatherName);
      formData.append('postalCode', vm.editInfo.postalCode);
      formData.append('birthday', vm.editInfo.birthday);
      formData.append('born_city', vm.editInfo.placeBirthday);
      formData.append('nid', this.english(vm.editInfo.nationalCode));
      formData.append('mcode', this.english(vm.editInfo.id));
      formData.append('nid_img', vm.editInfo.nationalCodePic);
      formData.append('selfieimg', vm.editInfo.picWithNationalCode);
      formData.append('address', vm.editInfo.address);
      formData.append('agree', 1);
      formData.append('bill', vm.editInfo.yourCatch);
      this.requestApiPost('confirmprofile',
          formData,
          this.configurationFile()).then(({data}) => {
            this.loading = false
        this.$toast.success('با موفقیت ثبت شد')
      }).catch(({response}) => {
        this.loading = false
        vm.errorsMessage = response.data.errors
        console.log(response)
      })

    },
    configurationFile() {
      return {
        headers: {'Content-Type': 'multipart/form-data'},
        onUploadProgress: function (progressEvent) {
          this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          this.$forceUpdate();
        }.bind(this)
      };
    }
  },

  watch: {
    editInfo() {
      if (this.editInfo.legalPersonStatus == true) {
        this.legalPersonStatus = true
      }
    }
  },
  mounted() {
    // console.log(this.editInfo.legalPersonStatus)
    if (this.editInfo.legalPersonStatus == true) {
      this.legalPersonStatus = true
    }
  },


  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: 'تکمیل پروفایل'}])
    this.$vuetify.rtl = true;
  }
};
</script>
